import React from 'react';
import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useUserContextController } from '../../context/UserContext';
import { Avatar, Typography } from '@mui/material';

const ProfilePage: React.FC = () => {
  const [userContext] = useUserContextController();
  const { user, company } = userContext;

  if (!user || !company) {
    return <Navigate to="home" replace />;
  }

  const ProfileSection = () => (
    <Box
      sx={{
        width: '100%',
        marginBottom: '50px'
      }}
    >
      <Typography
        sx={{
          maxWidth: '100%',
          wordWrap: 'break-word',
          fontWeight: '600',
          fontSize: '26px',
          marginBottom: '20px'
        }}
      >
        Profile
      </Typography>
      <Box
        sx={{
          marginBottom: '20px'
        }}
      >
        <Avatar
          src={user.profilePictureUrl}
          sx={{
            justifySelf: 'center',
            width: 100,
            height: 100,
            marginBottom: '20px'
          }}
        />
        <Typography
          sx={{
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          Name
        </Typography>
        <Typography
          sx={(theme) => ({
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '400',
            fontSize: '14px',
            color: theme.customColors.themeNeutralSecondaryColor
          })}
        >
          {user.fullName}
        </Typography>
      </Box>
      <Box
        sx={{
          marginBottom: '20px'
        }}
      >
        <Typography
          sx={{
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          Company
        </Typography>
        <Typography
          sx={(theme) => ({
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '400',
            fontSize: '14px',
            color: theme.customColors.themeNeutralSecondaryColor
          })}
        >
          {company.name}
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          {/* Check if user email > 1 */}
          {user.emails.length > 1 ? 'Emails' : 'Email'}
        </Typography>
        <Typography
          sx={(theme) => ({
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '400',
            fontSize: '14px',
            color: theme.customColors.themeNeutralSecondaryColor
          })}
        >
          {user.emails.map((email, idx) => {
            // Check if emails length > 0 and if is not last index, add trailing commas and space
            return `${email}${user.emails.length > 1 && idx !== user.emails.length - 1 ? ', ' : ''}`;
          })}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        flex: 1,
        padding: '16px',
        width: '600px',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        alignSelf: 'center',
        flexWrap: 'wrap'
      }}
    >
      <ProfileSection />
    </Box>
  );
};

export default ProfilePage;
